import fetch from "node-fetch";

/**
 * @description Download asset from asset url
 */
export const downloadAsset = async (assetUrl: string) => {
  if (!assetUrl) {
    return;
  }

  const response = await fetch(assetUrl);
  const { status } = response;
  const data = await response.arrayBuffer();

  if (status !== 200 || !data) {
    return;
  }

  return Buffer.from(data);
};
